import { useState, useEffect, useCallback } from 'react';
import {
  apiDelete as requestDelete,
  apiGet as requestGet,
  apiPatch as requestPatch,
  apiPost as requestPost,
  apiPut as requestPut,
} from '../lib/apiClient';

function withApiPrefix(endpoint) {
  return endpoint.startsWith('/api/') ? endpoint : `/api${endpoint}`;
}

export function useApi(endpoint) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const json = await requestGet(withApiPrefix(endpoint));
      setData(json);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}

export async function apiGet(endpoint) {
  return requestGet(withApiPrefix(endpoint));
}

export async function apiPost(endpoint, body) {
  return requestPost(withApiPrefix(endpoint), body);
}

export async function apiPut(endpoint, body) {
  return requestPut(withApiPrefix(endpoint), body);
}

export async function apiPatch(endpoint, body) {
  return requestPatch(withApiPrefix(endpoint), body);
}

export async function apiDelete(endpoint) {
  return requestDelete(withApiPrefix(endpoint));
}
